import { Box, Text } from "@chakra-ui/react";

export const LabeledValue = ({ label, value }: { label: string; value: string }) => (
  <Box>
    <Text fontSize="xs" color="smMuted" textTransform="uppercase" letterSpacing="wide">
      {label}
    </Text>
    <Text fontSize="sm" fontWeight="medium">
      {value}
    </Text>
  </Box>
);
